var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"brand"},[_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v("nando"),_c('span',[_vm._v("moreira")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }